import LegalDocument, { LegalSection, OwnershipNotice } from "../components/LegalDocument";

export default function MedicalDisclaimer() {
  return (
    <LegalDocument
      titleEn="Medical Disclaimer"
      titleAr="إخلاء المسؤولية الطبية"
      descriptionEn="Important health information about the role and limits of this app."
      descriptionAr="معلومات صحية مهمة حول دور هذا التطبيق وحدوده."
    >
      <LegalSection titleEn="Educational and Tracking Purposes Only" titleAr="لأغراض التعليم والتتبع فقط">
        {{
          childrenEn: (
            <p>
              Dialysis Diet Pro is for educational and tracking purposes only. It does not
              provide medical advice, diagnosis, or treatment and does not replace
              consultation with a doctor, nephrologist, or renal dietitian.
            </p>
          ),
          childrenAr: (
            <p>
              تطبيق Dialysis Diet Pro مخصص للأغراض التعليمية وللتتبع فقط. وهو لا يقدم
              نصيحة طبية أو تشخيصا أو علاجا، ولا يحل محل استشارة طبيب أو اختصاصي أمراض
              الكلى أو اختصاصي تغذية كلوية.
            </p>
          ),
        }}
      </LegalSection>

      <LegalSection titleEn="Nutrition Decisions" titleAr="قرارات التغذية">
        {{
          childrenEn: (
            <p>
              Nutrient records, food information, and summaries are provided for tracking
              purposes. Your appropriate diet and limits may depend on your individual
              medical plan. Confirm dietary decisions with your renal dietitian or medical
              team.
            </p>
          ),
          childrenAr: (
            <p>
              تقدم سجلات العناصر الغذائية ومعلومات الطعام والملخصات لأغراض التتبع. قد
              يعتمد النظام الغذائي والحدود المناسبة لك على خطتك الطبية الفردية. أكد
              قراراتك الغذائية مع اختصاصي التغذية الكلوية أو فريقك الطبي.
            </p>
          ),
        }}
      </LegalSection>

      <LegalSection titleEn="Medication and Urgent Care" titleAr="الأدوية والرعاية العاجلة">
        {{
          childrenEn: (
            <p>
              Reminders are organizational aids only. Do not start, stop, or change
              medication based on this app. For urgent symptoms or emergencies, contact
              appropriate medical or emergency services promptly.
            </p>
          ),
          childrenAr: (
            <p>
              التذكيرات أدوات تنظيمية فقط. لا تبدأ دواء أو توقفه أو تغيره اعتمادا على
              هذا التطبيق. عند وجود أعراض عاجلة أو حالة طارئة، تواصل بسرعة مع الجهات
              الطبية أو خدمات الطوارئ المناسبة.
            </p>
          ),
        }}
      </LegalSection>

      <OwnershipNotice />
    </LegalDocument>
  );
}
